import React from 'react';
import {Line} from 'react-chartjs-2';
import moment from 'moment';
import NumberFormat from 'react-number-format';

import {agencyTrendData, lineChartOptions} from '../common/LineGraph';


const AgencyRevenue = ({pageData = {}, settings={}}) => {

    let revenueGoals = [], revenueActuals = [], lyActuals = [], monthList = [];
    let currentMonthTarget = 0;

    if (pageData.revenues && pageData.revenues.length) {
        let currentMonth = moment().format("MMMM");

        pageData.revenues.map(revenue => {
            monthList.push(revenue.month_name);
            lyActuals.push(revenue.ly_actual || 0);
            if (revenue.ty_actual) {
                revenueActuals.push(revenue.ty_actual);
            }
            revenueGoals.push(revenue.ty_planned || 0);

            if (revenue.month_name === currentMonth) {
                currentMonthTarget = revenue.ty_target;
            }
        });

        // lineChartOptions.plugins.datalabels.display = true;
    }

    agencyTrendData.labels = monthList;
    agencyTrendData.datasets[0].data = revenueGoals;
    agencyTrendData.datasets[1].data = revenueActuals;
    agencyTrendData.datasets[2].data = lyActuals;

    return(
        <div className="container-fluid my-1">
            <div className="row">
                <div className="col-md-12 text-center">
                    <p className="display-6 font-weight-bold">
                        {pageData && pageData.title && pageData.title}
                        &nbsp;&nbsp;
                        <span className="font-32">(Current Month Target: &nbsp;
                            <NumberFormat value={currentMonthTarget} displayType={'text'} 
                                thousandSeparator={true} prefix={'$ '} 
                            />
                        )</span>
                    </p>
                    <span className="hor-bar"/>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Line data={agencyTrendData} 
                        height={100} 
                        width={275}
                        options={lineChartOptions} 
                    />
                </div>
            </div>
        </div>
    )
}
export default AgencyRevenue;



// WEBPACK FOOTER //
// ./src/components/agencyMonitor/AgencyRevenues.js